<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"900px"'
    :cpntTitulo='cpntTitulo'
    :cpntOnFecharDialog='appConsultarDemandaFechar'>
    <template slot='conteudo'>
      <!-- SETA O CAMPO BUSCA -->
      <div class="app-con-ven--busca" v-if="dados === null">
        <App-Autocompletar :data-time="time" :class="campos.busca.id"
          :cpntStatus='campos.busca.status'
          :cpntId='campos.busca.id'
          :cpntTabIndex='campos.busca.tabIndex'
          :cpntNome='campos.busca.nome'
          :cpntValue='campos.busca.value'
          :cpntMensagem='campos.busca.mensagem'
          :cpntMensagemTipo='campos.busca.mensagemTipo'
          :cpntDisabled='campos.busca.disabled'
          :cpntMostrar='campos.busca.mostrar === true'
          :cpntExplica='campos.busca.explica'
          :cpntPlaceholder='campos.busca.placeholder'
          :cpntValueRef='campos.busca.valueRef'
          :cpntRouter='campos.busca.router'
          :cpntMethod='campos.busca.method'
          :cpntField='campos.busca.field'
          :cpntWhere='campos.busca.where'
          :cpntAddButForm='campos.busca.addButForm'
          :cpntKeyMostra='campos.busca.keyMostra'
          :cpntTipoOrder='campos.busca.tipoOrder'
          :cpntOrder='campos.busca.order'
          :cpntOptions='campos.busca.options'
          :cpntKeyValue='campos.busca.keyValue'
          :cpntSearchMinimo='campos.busca.searchMinimo'
          :cpntMask='campos.busca.mask'
          :cpntNewOption='campos.busca.newOption'

          :cpntOnBuscarOptions='campos.busca.onBuscarOptions'
          :cpntOnChange='campos.busca.onChange'
          :cpntOnBlur='campos.busca.onBlur'
          :cpntOnRealizaBusca='campos.busca.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.busca.onKeyPressEnter'
          ref="busca"
        ></App-Autocompletar>
      </div>

      <div v-else class="app-con-ven--dados">
        <!-- MONTA OS BOTOES DA TELA-->
        <Demanda-Editar-Cabecalho
        :cpntDemanda="cpntDemanda"
        :cpntDemandaId="dados.cod_venda"
        :cpntCampos="[ 'numeracao', 'vencimento', 'status', 'contato', 'veiculo', 'pet', 'valores' ]"

        :cpntDemandaTotal="dados.virtual_total"
        :cpntPDocNFEmitida="false"
        :cpntSDocNFEmitida="false"
        :cpntPDocDocs="dados.p_doc_docs"
        :cpntFinStatus="dados.status_fin === '1' ? 's' : 'n'"
        :cpntPDV="[ '', null, undefined, '0' ].indexOf(dados.pdv_senha) === -1"
        :cpntDemData="dados.vencimento_ptbr"
        :cpntCreatedAt="dados.data_ptbr"

        :cpntIdCon="dados.id_con"
        :cpntIdConNome="dados.id_con_nome"
        :cpntIdConCnpjCpf="dados.id_con_cnpj_cpf"
        :cpntIdConEmpresa="dados.id_con_empresa"
        :cpntIdConPessoa="dados.id_con_pessoa"
        :cpntIdConStatus="dados.id_con_status"

        :cpntIdVei="dados.id_vei"
        :cpntIdVeiIdMod="dados.id_vei_id_mod"
        :cpntIdVeiIdModNome="dados.id_vei_id_mod_nome"
        :cpntIdVeiIdMar="dados.id_vei_id_mar"
        :cpntIdVeiIdMarNome="dados.id_vei_id_mar_nome"
        :cpntIdVeiPlaca="dados.id_vei_placa"
        :cpntIdVeiStatus="dados.id_vei_status"

        :cpntIdPet="dados.id_pet"
        :cpntIdPetNome="dados.id_pet_nome"    
        :cpntIdPetSubespecieNome="dados.id_pet_subespecie_nome"
        :cpntIdPetStatus="dados.id_pet_status"
        ></Demanda-Editar-Cabecalho>

        <!-- MONTA OS BOTOES DA TELA-->
        <Demanda-Editar-Botoes
        :cpntDemanda="cpntDemanda"
        :cpntDemandaId="dados.cod_venda">
        </Demanda-Editar-Botoes>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .app-con-ven--busca {
    padding-top: 25px;
    padding-bottom: 15px;
    width: 450px;
    margin: 0px auto;
  }
    .app-con-ven--busca > div {
      width: 100%;
    }
</style>

<style>
  .app-con-ven--dados > .dem-edi-bts > .item-titulo {
    display: none;
  }
</style>

<script>
  export default {
    props: {
      cpntTitulo: {
        required: false,
        default: function () {
          return 'Consultar Venda <b>[ALT+V]</b>'
        }
      },
      cpntDemanda: {
        required: false,
        default: function () {
          return 'venda'
        }
      },
      cpntCopiar: {
        required: false,
        default: function () {
          return false
        }
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'App-Demanda-Nova': () => import('@/components/demanda/Demanda-Nova.vue'),
      'Demanda-Editar-Cabecalho': () => import('@/components/demanda/Editar/Cabecalho/Demanda-Editar-Cabecalho.vue'),
      'Demanda-Editar-Botoes': () => import('@/components/demanda/Editar/Rodape/Demanda-Editar-Botoes.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        dados: null,
        campos: {
          busca: {
            id: 'dem-nova--busca',
            status: '',
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar nova venda' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.appConsultarDemandaAdicionarNovaVenda
            },
            nome: 'Buscar venda',
            router: '/venda/get',
            method: 'POST',
            field: { cod_venda: null, vencimento: null, id_con: { j: { nome: null } } },
            where: { aAnd: [ { f: 'status', o: 'in', v: '1,2' }, { aOr: [ { m: 'venda', o: 's.ft', v: '#BUSCA#' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' } ] } ] },
            tipoOrder: 'numero',
            order: { cod_venda: 'desc' },
            keyValue: 'cod_venda',
            keyMostra: [ 'cod_venda', ' - ', 'vencimento_ptbr', ' - ', 'id_con_nome' ],
            disabled: false,
            apiEnv: 'busca',
            mostrar: true,
            value: '',
            mensagem: '',
            mensagemTipo: '',
            onChange: this.appConsultarDemandaOnChange,
            onRealizaBusca: (busca) => {
              // LIMPA O VALOR DO CAMPO SELECIONADO
              this.campos.busca.value = busca

              // LIMPA O VALOR DO CAMPO SELECIONADO
              this.campos.busca.valueRef = ''
            }
          }
        }
      }
    },
    mounted: function () {
      this.appConsultarDemandaIniciar()
    },
    methods: {
      appConsultarDemandaIniciar: function () {
        // SETA O STATUS DA TELA
        this.appConsultarDemandaSetarStatusGeral('carregando')

        // VERIFICA SE TEM OS PACOTES PARA APRESENTAR AS OPÇÕES
        this.pacotePet = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true
        this.pacoteVeiculo = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true

        // REALIZA O FOCUS NO CAMPO BUSCA
        this.appConsultarDemandaRealizarFocusCampo('busca')

        // SETA O STATUS DA TELA
        this.appConsultarDemandaSetarStatusGeral('')
      },
      appConsultarDemandaFechar: function (atualizar, id = '', dados = null) {
        this.cpntFecharFormulario(atualizar, id, dados)
      },
      appConsultarDemandaSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appConsultarDemandaOnChange: function (cod_venda) {
        if (typeof cod_venda !== 'string') {
          this.appConsultarDemandaOnChange(cod_venda.cod_venda)
        } else {
          // SETA O STATUS DA TELA
          this.appConsultarDemandaSetarStatusGeral('carregando')

          // INICIA A QUERY QUE SERÁ SOLICITADA
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE SER BUSCADOS
          queryGet.field = {
            cod_venda: null,
            cms_status: null,
            vencimento: null,
            data: null,
            status: null,
            id_pco_item: { j: { id_pco_status_item: { j: { nome: { a: 'id_pco_item_nome' }, cor: { a: 'id_pco_item_cor_fundo' }, id_pco_status: null } } } },
            id_pet: { j: { id_con: null, nome: null, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' }, id_especie: { j: { especie: null } } } }, status: null } },
            id_vei: { j: { id_con: null, placa: null, km: null, id_mod: { j: { nome: null } }, id_mar: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } }, status: null } },
            id_con: { j: { nome: null, empresa: null, cnpj_cpf: null, pessoa: null, pj_sn: null, id_estado: null, status: null, id_cms: { j: { nome: null } } } },
            status_fin: null,
            pdv_senha: null,
            p_doc_docs: null,
            // p_doc_docs: { j: {
            //   tpAmb: null,
            //   DocModelo: null,
            //   DocNumero: null,
            //   DocSerie: null,
            //   DocDhAut: null,
            //   DocDhAutFuso: null,
            //   DocChaAcesso: null,
            //   SitCodigo: null,
            //   SitCodigo_log: null,
            //   email_last_at: null,
            //   email_json_log: null
            // } },
          }

          // SETA OS FIELDS VIRTUAL QUE DEVE CHAMAR
          queryGet.field_virtual = [ 'total' ]

          // // VERIFICA SE TEM QUE BUSCAR CARTA DE CORREÇÃO
          // if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20 ], null, null, null, null, null, false) === true) {
          //   queryGet.field_virtual = queryGet.field_virtual.concat([ 'p_doc_cce' ])
          // }

          // // VERIFICA SE TEM O PACOTE SERVICO
          // if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 25 ], null, null, null, null, null, false) === true) {
          //   queryGet.field_virtual = queryGet.field_virtual.concat([ 's_doc' ])
          // }

          // SETA A QUERY QUE DEVE FAZER
          queryGet.where = { aAnd: [
            { f: 'status', o: '<>', v: '3' },
            { f: 'cod_venda', o: '=', v: cod_venda }
          ] }

          // REALIZA A BUSCA DOS DADOS NA API
          this.$store.state.comunicaAPI('/venda/get', 'POST', queryGet, (retorno) => {
            if ([ '', null, undefined ].indexOf(retorno.data) !== -1 || retorno.data.length !== 1) {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.msgWarn('WEB [406]: Venda (' + cod_venda + ') informada não foi localizada.', 'warning')

              // MANDA FECHAR A TELA
              this.appConsultarDemandaFechar()
            } else {
              // VERIFICA SE TEM CONVERTER PARA NOVO VALOR
              if ([ '', null, undefined ].indexOf(retorno.data[0].id_vei_ref_modelo) === -1) {
                // CONVERTE O MODELO
                retorno.data[0].id_vei_id_mod = retorno.data[0].id_vei_ref_modelo
                retorno.data[0].id_vei_id_mod_nome = retorno.data[0].id_vei_ref_modelo_j_modelo

                // CONVERTE A MARCA
                retorno.data[0].id_vei_id_mar = retorno.data[0].id_vei_ref_modelo_id_marca
                retorno.data[0].id_vei_id_mar_nome = retorno.data[0].id_vei_ref_modelo_id_marca_j_marca
              }

              // CONVERTE O VALOR DO VEICULO
              retorno.data[0].id_vei = ([ '', null, undefined, '0' ].indexOf(retorno.data[0].id_vei) === -1 ? retorno.data[0].id_vei : '')

              // VERIFICA SE TEM A CHAVE DE VALORES
              if ([ '', null, undefined ].indexOf(retorno.data[0].virtual_total) === -1) {
                for (var indexT in retorno.data[0].virtual_total) {
                  for (var indexC in retorno.data[0].virtual_total[indexT]) {
                    switch (indexC) {
                      case 'creDevolucao':
                      case 'desconto':
                      case 'liquido':
                      case 'retencao':
                      case 'frete':
                      case 'oda':
                      case 'seguro':
                      case 'total':
                      case 'taxa':
                        retorno.data[0].virtual_total[indexT]['_' + indexC] = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[0].virtual_total[indexT][indexC])
                        break
                    }
                  }
                }
              }

              // SETA OS DADOS RECEBIDOS
              this.dados = retorno.data[0]

              // SETA O STATUS DA TELA
              if (this.cpntCopiar === true) {
                this.appConsultarDemandaFechar(true, this.dados.cod_venda, this.dados)
              } else {
                this.appConsultarDemandaSetarStatusGeral('')
              }
            }
          }, this.appConsultarDemandaSetarStatusGeral)
        }
      },
      appConsultarDemandaAdicionarNovaVenda: function () {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { tipo: 'DEMANDA_NOVA', demanda: 'venda', redirecionar: this.cpntCopiar === false }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id) => {
          if (atualizar === true) {
            this.appConsultarDemandaOnChange(id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      appConsultarDemandaRealizarFocusCampo: function (chave, tentativa = 0) {
        // SETA O FOCUS NO CAMPO
        if (this.$store.state.mobile === false && tentativa <= 10) {
          if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
            this.$refs[chave].cpntRealizarFocus()
          } else {
            setTimeout(() => { this.appConsultarDemandaRealizarFocusCampo(chave, (tentativa + 1)) }, 250)
          }
        }
      },
    }
  }
</script>
